export default __webpack_public_path__ + "static/media/aboutslider5.df743396.webp";